import List from "@/components/list";
import Bus from "./Bus.js";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  function handleDelete(vo) {
    Bus.$emit("deleteVideoSet", vo.$index);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-delete-disable", "删除", () => handleDelete(vo), ""]
      // ["icon-up", "上线", () => upLine(vo), ""],
      // ["icon-down", "下线", () => downLine(vo), ""],
    ];
    // v-permission={item[2]}
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "视频名称",
      prop: "videoName",
      minWidth: "150"
    },
    {
      label: "讲师",
      prop: "lecturerName",
      minWidth: "100"
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "100"
    },
    {
      label: "审核状态",
      prop: "videoAuditStatusName",
      minWidth: "100"
    },
    {
      label: "操作",
      minWidth: "200",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
